<template>
  <div>
    <el-card shadow="never" class="mt-24" header="Collateral Information">
      <customize-form
        ref="collateralInfo"
        :schema="collateralInfoSchema"
        :model="detailData.collateralInformation || {}"
      >
        <el-upload
          action=""
          multiple
          :auto-upload="false"
          :limit="15"
          :on-exceed="handleExceed"
          :file-list="CFileList"
          :show-file-list="false"
          :on-change="handleChangeUpload"
        >
          <customize-button>Upload Documents</customize-button>
        </el-upload>
        <ul class="file-list">
          <li
            class="list-item"
            v-for="(item, index) in CFileList"
            :key="index"
            @click="handleDownload(item)"
          >
            {{ item.name }}
            <el-popconfirm
              title="Confirm to delete？"
              confirm-button-text="confirm"
              cancel-button-text="cancel"
              @confirm="handleRemoveItem(item, index)"
            >
              <a href="javascript: void (0)" @click.stop slot="reference">
                Delete
              </a>
            </el-popconfirm>
          </li>
        </ul>
      </customize-form>
    </el-card>

    <div v-show="radioValue === 1">
      <!--Guarantor Basic Information-->
      <el-card
        shadow="never"
        header="Guarantor Basic Information"
        class="mt-24"
      >
        <customize-form
          ref="guarantorBasicInfo"
          :schema="guarantorBasicInfoSchema"
          :model="detailData.guarantorBasicInformation || {}"
        />
      </el-card>
    </div>
    <!--L/C Information-->
    <div v-show="[2, 3].includes(radioValue)">
      <el-card shadow="never" header="L/C Information" class="mt-24">
        <customize-form
          ref="LCInfo"
          :schema="LCInfoSchema"
          :model="detailData.lcInformation || {}"
        />
      </el-card>
    </div>

    <div v-show="[2, 3].includes(radioValue)">
      <!-- Issuer Bank-->
      <el-card shadow="never" header="Issuer Bank" class="mt-24">
        <customize-form
          ref="issuerBank"
          :schema="issuerBankSchema"
          :model="(detailData.bankInfo && detailData.bankInfo[0]) || {}"
        />
      </el-card>
      <!--Advising Bank-->
      <el-card shadow="never" header="Advising Bank" class="mt-24">
        <customize-form
          ref="advisingBank"
          :schema="advisingBankSchema"
          :model="(detailData.bankInfo && detailData.bankInfo[1]) || {}"
        />
      </el-card>
      <!--Confirmation Bank-->
      <el-card shadow="never" header="Confirmation Bank" class="mt-24">
        <customize-form
          ref="confirmationBank"
          :schema="confirmationBankSchema"
          :model="(detailData.bankInfo && detailData.bankInfo[2]) || {}"
        />
      </el-card>
    </div>
    <div class="btn-wrapper">
      <customize-button style="margin-right: 20px" @click="cancelBtn">
        Cancel
      </customize-button>
      <customize-button
        type="primary"
        @click="handleSaveBtn"
        :loading="saveBtnLoading"
      >
        Save
      </customize-button>
    </div>
  </div>
</template>

<script>
import {
  getSelectList,
  getCurrencyList,
  commonUpload,
  commonRemoveFile,
  commonDownload,
} from '@/api'
import LCInfoSchema from './mixin/LCInfoSchema'
import issuerBankSchema from './mixin/issuerBankSchema'
import advisingBankSchema from './mixin/advisingBankSchema'
import confirmationBankSchema from './mixin/confirmationBankSchema'

import { addCol, editCol, getColDetail } from './api'
const UPLOAD_READY = 'ready'
export default {
  mixins: [
    LCInfoSchema,
    issuerBankSchema,
    advisingBankSchema,
    confirmationBankSchema,
  ],
  data() {
    this.typeList = [
      {
        id: 1,
        name: 'Inter-corporate Guarantee',
      },
      {
        id: 2,
        name: 'Third-party Guarantee',
      },
      {
        id: 3,
        name: 'Bank',
      },
      {
        id: 4,
        name: 'Standard L/C',
      },
      {
        id: 5,
        name: 'Documentary L/C',
      },
      {
        id: 6,
        name: 'Standby L/C',
      },
      {
        id: 7,
        name: 'Corporate Guarantee',
      },
      {
        id: 8,
        name: 'Parent Guarantee',
      },
      {
        id: 9,
        name: 'Deposit',
      },
      {
        id: 10,
        name: 'Bank Guarantee',
      },
      {
        id: 11,
        name: 'Letter of Credit',
      },
      {
        id: 12,
        name: 'Other',
      },
      {
        id: 13,
        name: 'Real Estate',
      },
      {
        id: 14,
        name: 'Equipment',
      },
      {
        id: 15,
        name: 'Credit Guarantee',
      },
      {
        id: 16,
        name: 'Insurance Guarantee',
      },
    ]

    const collateralInfoSchema = [
      {
        label: 'Collateral Category',
        type: 'select',
        value: 1,
        key: 'collateralCategory',
        selectList: [
          {
            name: 'Corporate Guarantee',
            id: 1,
          },
          {
            name: 'Bank Guarantee',
            id: 2,
          },
          {
            name: 'Letter of Credit',
            id: 3,
          },
          {
            name: 'Deposit',
            id: 4,
          },
          {
            name: 'Other',
            id: 5,
          },
        ],
        change: (value, formData) => this.handleChange(value, formData),
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Collateral Type',
        type: 'select',
        key: 'collateralType',
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
        selectList: [],
      },
      {
        label: 'Collateral Amount',
        type: 'input',
        key: 'collateralAmount',
        input: value => this.handleAmountChange(value),
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'blur' },
        ],
      },
      {
        label: 'Currency',
        type: 'select',
        key: 'currency',
        selectList: [],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Encash Amount',
        type: 'input',
        key: 'encashAmount',
      },
      {
        label: 'Encash Date(YYYY-MM-DD)',
        type: 'date',
        key: 'encashDate',
      },
      {
        label: 'Effective Date(YYYY-MM-DD)',
        type: 'date',
        key: 'effectiveDate',
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Expiration Date(YYYY-MM-DD)',
        type: 'date',
        key: 'expirationDate',
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Beneficiary',
        type: 'input',
        key: 'beneficiary',
      },
      {
        label: 'Contact Phone',
        type: 'input',
        key: 'contactPhone',
      },
      {
        label: 'Relative Weight',
        type: 'input',
        key: 'relativeWeight',
      },
      {
        label: 'Conversion Date(YYYY-MM-DD)',
        type: 'date',
        key: 'conversionDate',
      },
      {
        label: 'Contact Name',
        type: 'input',
        key: 'contactName',
      },
      {
        label: 'Contact Email',
        type: 'input',
        key: 'contactEmail',
      },
      {
        label: 'Location',
        type: 'input',
        key: 'location',
        rules: [
          {
            min: 0,
            max: 500,
            message: 'No more than 500 characters.',
            trigger: 'blur',
          },
        ],
      },
      {
        label: 'Comments',
        type: 'textarea',
        key: 'comments',
      },
    ]
    const guarantorBasicInfoSchema = [
      {
        label: 'Customer #',
        type: 'input',
        key: 'customer',
      },
      {
        label: 'Customer',
        type: 'checkbox',
        key: 'customerCheck',
      },
      {
        label: 'Customer Name',
        type: 'input',
        key: 'customerName',
      },
      {
        label: 'City',
        type: 'input',
        key: 'city',
      },
      {
        label: 'Address',
        type: 'input',
        key: 'address',
      },
      {
        label: 'Zip Code',
        type: 'input',
        key: 'zipcode',
      },
      {
        label: 'Country',
        type: 'select',
        key: 'country',
        selectList: [],
      },
      {
        label: 'Extension',
        type: 'input',
        key: 'extension',
      },
      {
        label: 'State',
        type: 'input',
        key: 'state',
      },
      {
        label: 'Tax ID',
        type: 'input',
        key: 'taxID',
      },
      {
        label: 'Phone #',
        type: 'input',
        key: 'phone',
      },
      {
        label: 'Duns #',
        type: 'input',
        key: 'duns',
      },
      {
        label: 'Experian BIN',
        type: 'input',
        key: 'experianBIN',
      },
    ]
    return {
      isShowCollateralInformation: false,
      radioValue: 1,
      collateralInfoSchema,
      guarantorBasicInfoSchema,
      detailData: {},
      saveBtnLoading: false,
      CFileList: [],
      acceptFileTypes: [
        'png',
        'gif',
        'pjp',
        'jpg',
        'jpeg',
        'bmp',
        'csv',
        'xlsm',
        'xltm',
        'ico',
        'xls',
        'xlsx',
        'doc',
        'docx',
        'pdf',
        'ppt',
        'pptx',
        'txt',
        'rar',
        'zip',
        'html',
        'msg',
      ],
      downloadUrl: '',
    }
  },
  mounted() {
    this._getSelectList()
    this._getCurrencyList()
    if (this.$route.query.id) {
      this._getColDetail()
    }
    this._filterTypeList()
  },
  computed: {
    fileList() {
      return this.detailData?.collateralInformation?.files || []
    },
  },
  methods: {
    handleDownload(raw) {
      const { id } = raw
      if (!this.downloadUrl && id) {
        commonDownload(id)
      }
    },
    async handleRemoveItem({ id }, index) {
      if (id) {
        await commonRemoveFile(id)
        this.$message.success('success')
      }
      this.CFileList.splice(index, 1)
    },
    handleChangeUpload(file) {
      // 判断文件后缀格式
      const _index = file.name.lastIndexOf('.')
      const _type = file.name.substr(_index + 1)
      if (this.acceptFileTypes.indexOf(_type) === -1) {
        this.$message.error(`.${_type} is invalid`)
        this.CFileList = [...this.CFileList]
        return
      }
      // 单个文件不能超过50M
      const fileSize = Number(file.size / 1024 / 1024)
      if (file.status === UPLOAD_READY && fileSize < 50) {
        this.CFileList.push(file)
      } else {
        this.$message.error('File must not exceed 50M')
        this.CFileList = [...this.CFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
      }
    },
    handleExceed() {
      this.$message.warning(
        'Maximum fifteen files can be uploaded. Each file cannot exceed 50M.',
      )
    },
    _filterTypeList(value = 1) {
      let arr = []
      if (value === 1) {
        arr = this.typeList.slice(0, 2)
      } else if (value === 2) {
        arr = this.typeList.slice(2, 3)
      } else if (value === 3) {
        arr = this.typeList.slice(3, 6)
      } else if (value === 4) {
        // 只要一个deposit
        arr = this.typeList.slice(8, 9)
      } else if (value === 5) {
        arr = this.typeList.slice(11)
      }
      this.collateralInfoSchema[1].selectList = arr
    },
    async handleAmountChange(value) {
      value = this.$utils.setSeperatenum(value)
      this.collateralInfoSchema = this.collateralInfoSchema.map(item => {
        if (item.key === 'collateralAmount') {
          item.value = value
        }
        return item
      })
    },
    handleChange(value, formData) {
      this.radioValue = value
      this._filterTypeList(value)
      this.detailData.collateralInformation = { ...formData }
      this.detailData.collateralInformation.collateralType = ''
    },
    async _getCurrencyList() {
      try {
        let currencyList = await getCurrencyList()
        currencyList = currencyList.map(item => ({
          id: item.currency,
          name: item.currencyName,
        }))

        for (let i = 0; i < this.collateralInfoSchema.length; i++) {
          if (this.collateralInfoSchema[i].key === 'currency') {
            this.collateralInfoSchema[i].selectList = currencyList
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async _getSelectList() {
      try {
        const data = await getSelectList('Country')
        this.guarantorBasicInfoSchema.forEach(item => {
          if (item.key === 'country') {
            item.selectList = data
          }
        })
      } catch (err) {
        console.error(err)
      }
    },
    async handleUpload() {
      const fileList = this.CFileList
      const resetFileList = fileList.filter(file => !file.id)
      if (!resetFileList.length) {
        return false
      }
      const formData = new FormData()
      resetFileList.forEach(item => {
        formData.append('file', item.raw)
      })
      let documentId = ''
      if (this.detailData && this.detailData.collateralInformation) {
        documentId = this.detailData.collateralInformation.documentId
      }
      if (documentId) {
        formData.append('id', documentId)
      }
      formData.append('companyId', this.$route.params.customerId)
      return await commonUpload(formData)
    },
    async handleSaveBtn() {
      const valid = await this.$refs.collateralInfo.validateFields()
      if (valid) {
        this.saveBtnLoading = true
        const id = await this.handleUpload()
        const collateralInformation = this.$refs.collateralInfo.getFormData()
        collateralInformation.collateralAmount = this.$utils.resetAmount(
          collateralInformation.collateralAmount,
        )
        const { radioValue } = this

        collateralInformation.companyId = this.$route.params.customerId
        if (id) {
          collateralInformation.attachmentId = id
        }

        if (radioValue === 1) {
          const guarantorBasicInformation =
            this.$refs.guarantorBasicInfo.getFormData()

          await this.updateAndAdd({
            collateralInformation,
            guarantorBasicInformation,
          })
        } else if ([2, 3].includes(radioValue)) {
          const bankInfo = [
            'issuerBank',
            'advisingBank',
            'confirmationBank',
          ].map((refName, index) => {
            const res = this.$refs[refName].getFormData()
            res.bankType = index + 1
            return res
          })
          const submitData = {
            collateralInformation,
            bankInfo,
          }
          if (radioValue === 2) {
            submitData.lcInformation = this.$refs.LCInfo.getFormData()
          }
          await this.updateAndAdd(submitData)
        } else if (radioValue === 4) {
          await this.updateAndAdd({
            collateralInformation,
          })
        } else if (radioValue === 5) {
          await this.updateAndAdd({
            collateralInformation,
          })
        }
      }
    },
    async updateAndAdd(params) {
      try {
        const id = this.$route.query.id

        if (id) {
          await editCol(id, params)
        } else {
          await addCol(params)
        }
        this.$message.success('success')
        this.$router.go(-1)
      } catch (err) {
        this.saveBtnLoading = false
        console.error(err)
      }
    },
    async cancelBtn() {
      this.$router.go(-1)
    },
    async _getColDetail() {
      try {
        const data = await getColDetail(this.$route.query.id)
        this.radioValue = data.collateralInformation.collateralCategory
        this._filterTypeList(this.radioValue)
        this.detailData = { ...data }
      } catch (err) {
        console.log(err)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.top {
  .title {
    font-size: 16px;
    color: #3a3f63;
    line-height: 24px;
    margin-bottom: 26px;
  }

  .el-col {
    margin-bottom: 21px;
  }
}
.btn-wrapper {
  text-align: right;
}
.cart-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .title {
    font-size: 16px;
    color: #3a3f63;
    font-weight: bold;
  }
}
.upload-list {
  display: inline-block;
  width: 200px;
  line-height: 44px;
  font-size: 16px;
  color: #3a3f63;
  margin-left: 20px;
  @include no-wrap();
}
.file-list {
  margin-top: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    line-height: 30px;
    padding: 0 10px;
    border-radius: 8px;

    &:hover {
      background-color: #e2e2e5;
    }
  }
}
</style>
